import { useCallback, useEffect, useRef } from "react";

import { CampaignStatus } from "@/enum/campaign-status.enum";

import { listSelector } from "@/pages/Private/redux/list/list.slice";
import { useLazyGetListQuery } from "@/pages/Private/redux/list/list.api";
import { useAppSelector } from "@/redux/hooks";

const POLLING_INTERVAL_MS = 5000;

export function useCampaignStatusPolling(): void {
	const { lists } = useAppSelector(listSelector);
	const [getList] = useLazyGetListQuery();
	const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

	const pollLoadingLists = useCallback(() => {
		const loadingLists = lists.filter((list) => list.campaignStatus === CampaignStatus.LOADING);

		if (loadingLists.length === 0) {
			if (intervalRef.current) {
				clearInterval(intervalRef.current);
				intervalRef.current = null;
			}

			return;
		}

		loadingLists.forEach((list) => {
			getList(list.id);
		});
	}, [lists, getList]);

	useEffect(() => {
		const hasLoadingLists = lists.some((list) => list.campaignStatus === CampaignStatus.LOADING);

		if (hasLoadingLists && !intervalRef.current) {
			intervalRef.current = setInterval(pollLoadingLists, POLLING_INTERVAL_MS);
		} else if (!hasLoadingLists && intervalRef.current) {
			clearInterval(intervalRef.current);
			intervalRef.current = null;
		}

		return () => {
			if (intervalRef.current) {
				clearInterval(intervalRef.current);
				intervalRef.current = null;
			}
		};
	}, [lists, pollLoadingLists]);
}
